/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData
 */
export interface FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData
     */
    Token: string;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData
     */
    LoginCredentialType: FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType;
}



/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData(value: object): value is FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    if (!('LoginCredentialType' in value) || value['LoginCredentialType'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
        'LoginCredentialType': FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeFromJSON(json['LoginCredentialType']),
    };
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
        'LoginCredentialType': FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeToJSON(value['LoginCredentialType']),
    };
}

